import React from 'react';
import Colors from '../../../utils/colors';

class FormButton extends React.Component {
  render() {
    const { field } = this.props;
    const color = Colors.inputColors(field.color);
    let buttonClasses = `text-white ${color.buttonBg} ${color.buttonHoverBg} border-0 py-2 px-8 focus:outline-none rounded text-lg ${field.block ? 'w-full' : ''} ${field.centered ? 'block mx-auto' : ''}`;
    if (this.props.submitting) {
      buttonClasses = `${buttonClasses} opacity-50 cursor-not-allowed`;
    }
    return (
      <button
        className={buttonClasses}
        type="button"
        onClick={this.props.submitForm}
        disabled={this.props.submitting ? 'disabled' : ''}
      >{field.text}</button>
    );
  }
};

export default FormButton;